import { breakpoints } from "../hooks/useBreakpoint";

const mq = (breakpoint) => `@media (min-width: ${breakpoints[breakpoint]}px)`;

export default mq;
